import { FEEDBACK_PATH } from '../../../modules/feedback/constants'
import { FEEDBACK_MODEL_KEY } from '../../../modules/feedback/model'
import settingsMessages from '../../../modules/settings-ui/messages'
import { defineMessages } from 'react-intl'

const FEEDBACK_MODEL_CLASS_NAME = 'Feedback'

const FEEDBACK_MODEL_ASSOCIATIONS = [
  FEEDBACK_MODEL_KEY.REPLIES,
  FEEDBACK_MODEL_KEY.PROFILE,
  FEEDBACK_MODEL_KEY.USER
]

const FEEDBACK_MODEL_STATUS = {
  OPEN: 1,
  IN_PROGRESS: 2,
  CLOSED: 3
}

const FEEDBACK_MODEL_STATUS_TO_MESSAGE = defineMessages({
  1: {
    id: 'feedbackStatus.open',
    defaultMessage: 'Open',
    description: 'The feedback’s opened status.'
  },
  2: {
    id: 'feedbackStatus.inProgress',
    defaultMessage: 'In Progress',
    description: 'The feedback’s in progress status.'
  },
  3: {
    id: 'feedbackStatus.closed',
    defaultMessage: 'Closed',
    description: 'The feedback’s closed status.'
  }
})

const FEEDBACK_MODEL_TYPE = {
  BUG: 1,
  QUESTION: 2,
  GENERAL_FEEDBACK: 3
}

const FEEDBACK_MODEL_TYPE_TO_MESSAGE = {
  [FEEDBACK_MODEL_TYPE.BUG]: settingsMessages.reportProblem,
  [FEEDBACK_MODEL_TYPE.QUESTION]: settingsMessages.question,
  [FEEDBACK_MODEL_TYPE.GENERAL_FEEDBACK]: settingsMessages.generalFeedback
}

const FEEDBACK_MODEL_STATUS_TO_FEEDBACK_DOMAIN_LIST_PATH = {
  [FEEDBACK_MODEL_STATUS.OPEN]: FEEDBACK_PATH.OPEN,
  [FEEDBACK_MODEL_STATUS.IN_PROGRESS]: FEEDBACK_PATH.IN_PROGRESS,
  [FEEDBACK_MODEL_STATUS.CLOSED]: FEEDBACK_PATH.CLOSED
}

export {
  FEEDBACK_MODEL_CLASS_NAME,
  FEEDBACK_MODEL_ASSOCIATIONS,
  FEEDBACK_MODEL_TYPE,
  FEEDBACK_MODEL_STATUS,
  FEEDBACK_MODEL_STATUS_TO_MESSAGE,
  FEEDBACK_MODEL_TYPE_TO_MESSAGE,
  FEEDBACK_MODEL_STATUS_TO_FEEDBACK_DOMAIN_LIST_PATH
}
